import React, { useEffect } from 'react';
import ResolutionDropdown from 'components/toolbar/ResolutionDropdown.js';

export default function RollAndResolutionDocumentation(props) {
    return (
        <div>
          <p className="sub-header">
            Resolution
          </p>
          <p>
            The <b>resolution</b> dropdown at the top-left of the sequencer controls
            the <b>resolution</b> at which the steps are shown. By default, the resolution
            is set to 1/16th notes. Meaning you will see 16 steps per bar. 
          </p>
          <p>
            You can choose between several resolution types, including triplets. 
          </p>
          <p>
            It also controls how <b>rolling</b> and <b>quantization</b> is performed.
          </p>
          <p>
            <ResolutionDropdown sequencerEngine={props.sequencerEngine}/>
            <div className="clear-fix"/>
          </p>
          <p>
            For example, when <b>resolution</b> is set to 1/8 notes, any recorded triggers will be snapped to the 1/8th note grid.
          </p>
          <p className="sub-header">
            Rolling
          </p>
          <p>
            When <b>roll</b> is turned on, the <b>resolution</b> controls the rate at which the triggers are played, when live-triggered.
          </p>
          <p>
            For example, when <b>roll</b> is turned on, with <b>resolution</b> set to 1/16, if you trigger that track with your computer keyboard or MIDI
            controller, it will trigger once every 1/16th note. This is great for playing drum samples live.
          </p>
          <p className="sub-header">
            Sequence Rolling
          </p>
          <p>
            When <b> roll</b> is turned on, you can force the entire sequence to roll by pressing the <b>` key</b> (i.e. the backwards quote letter to the left of the 1 key).
          </p>
          <p>
            When the entire sequence is <b>rolling</b>, the sequencer will repeatedly cycle through the steps at which the <b>` key</b> was first pressed, for as many steps as the <b>resolution</b> defines.
          </p>
          <p>
            This can be thought of as a beat-repeat function, or "drum roll" function (in some existing drum machines). It allows you to perform the sequencer like a live instrument.
          </p>
          <p className="sub-header">
            Keyboard Shortcuts
          </p>
          <p>
            To turn <b>Roll</b> on, type the <b>'</b> (forward quote) key.
          </p>
          <p>
            To alter the <b>resolution</b> while rolling, use the following keyboard shortcuts. This is particularly effective while live-performing.
          </p>
          <p>
            The keyboard shortcuts are the number keys (note <b>Roll</b> must be turned on).
            <ul>
            <li><b>2:</b> 1/4</li>
            <li><b>3:</b> 1/4 (triplets)</li>
            <li><b>4: </b> 1/8</li>
            <li><b>5:</b> 1/8 (triplets)</li>
            <li><b>6: </b>1/16</li>
            <li><b>7:</b> 1/16 (triplets)</li>
            <li><b>8:</b> 1/32</li>
            <li><b>9:</b> 1/32 (triplets)</li>
            </ul>
          </p>
          <p>
            Get comfortable with these key bindings, along with <b>sequence rolling</b> to unlock new grooves you hadn't thought of.
          </p>
        </div>
    );
}
